import type { ReportSortSetting } from "@/stores/reportSort"

// Custom Table 화면 정렬의 클라이언트 영속화 (#99 — 정렬 저장 요구, 서버 저장은 미지원 WEB-2193).
// 템플릿(sortSetting)에는 쓰지 않고 브라우저 localStorage 에 리포트 종류·템플릿·섹션 단위로 보존한다.
// 새로고침·재진입 시 reportSort(transient store)에 seed 되어 화면·PDF 가 같은 정렬을 쓴다.
const STORAGE_KEY = "report-custom-table-sort"

type SortStore = Record<string, ReportSortSetting>

export function buildPersistedSortKey(
  reportType: string,
  templateId: string | number | null | undefined,
  sectionIndex: number,
): string {
  return `${reportType}:${templateId ?? "-"}:${sectionIndex}`
}

function readStore(): SortStore {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)

    return stored ? (JSON.parse(stored) as SortStore) : {}
  } catch {
    return {}
  }
}

export function loadCustomTableSort(key: string): ReportSortSetting | undefined {
  const sort = readStore()[key]
  if (!sort || !sort.key || (sort.order !== "asc" && sort.order !== "desc")) {
    return undefined
  }

  return sort
}

export function saveCustomTableSort(key: string, sort: ReportSortSetting | undefined): void {
  try {
    const store = readStore()
    if (sort) {
      store[key] = sort
    } else {
      delete store[key]
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store))
  } catch (e) {
    console.error("Failed to save custom table sort to localStorage:", e)
  }
}
